import { Slide } from '@core/slide-management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/slide-deck'].update({
        staticData: { title: { page: 'Content.Slides.PageHeading', forWebinar: true } },
        component: authGuard(Slide, { canBroadcast: true })
    });
};
